export const authMiddleware = (store) => (next) => (action) => {
  return next(action);
};
